import { FC } from 'react';

import { ColorSelector } from 'components/_basic/ColorSelector/ColorSelector';

import { DocumentStyleSelector } from '../DocumentStyleSelector/DocumentStyleSelector';

export const PreviewModeComponent: FC = () => {
  return (
    <>
      <ColorSelector />
      <DocumentStyleSelector />
    </>
  );
};
